import URL from '@/tools/url';
import jquery from 'jquery';
import _forIn from 'lodash/forIn';
import _toFinite from 'lodash/toFinite';

/**
 * @memberof module:ajaxAPI/cart
 * @alias add
 *
 * @description
 * Добавление товара в корзину.
 *
 * @param {Object} items -  объект с добавляемыми модификациями и их кол-вом {variant_id: quantity, ...}
 * @param {Object} options - объект с дополнительными полями: comments, coupon
 * @param {Object} options.comments - объект с комментариями вида {variant_id: comment, ...}
 * @param {string} options.coupon - название купона
 *
 * @return {$.ajax}
 *
 * @example
 * var items = {
 *   123456: 1,
 *   123457: 3,
 *   123450: 100
 * };
 *
 * var options = {
 *   comments: { 123456: 'Ваш комментарий' },
 *   coupon: 'test'
 * }
 *
 * ajaxAPI.cart.add(items, options)
 *  .done(function (onDone) { console.log ('onDone: ', onDone) })
 *  .fail(function (onFail) { console.log ('onFail:', onFail) });
 */
export default function(items, options) {
  var _lang = URL.getKeyValue('lang') || '';
  var fields = { lang: _lang };

  options = options || {};

  _forIn(items, function(quantity, variant_id) {
    fields['variant_ids[' + variant_id + ']'] = _toFinite(quantity);
  });

  _forIn(options.comments, function(comment, variant_id) {
    var item = window.InsalesCommonCart.order.getItemByID(variant_id);
    var thisComment = (item) ? item.comment : '';
    if (window.InsalesCommonCart.order.getItemByID(variant_id) && thisComment !== comment) {
      fields['cart[order_line_comments][' + variant_id + ']'] = comment;
    } else if (!item) {
      fields['cart[order_line_comments][' + variant_id + ']'] = comment;
    }
  });

  if (options.coupon) {
    fields['cart[coupon]'] = options.coupon;
  }

  return jquery.post('/cart_items.json', fields);
}
